document.querySelector(".wti-modal-btn").addEventListener("click", openModal);
document.querySelector(".wire-modal-close-btn").addEventListener("click", closeModal);

const modal = document.querySelector("#wireTransferModal");
if (modal && modal.parentNode !== document.body) {
  document.body.appendChild(modal);
}

function openModal() {
  document.querySelector("#wireTransferModal").classList.add('open');
  document.querySelector('.template-product').style.overflow = "hidden";
}

function closeModal() {
  document.querySelector("#wireTransferModal").classList.remove('open');
  document.querySelector('.template-product').style.overflow = "unset";
}

document.addEventListener("click", function(event) {
  const modal = document.querySelector("#wireTransferModal");
  const modalContent = modal.querySelector(".modal-content"); 
  const wtiButton = document.querySelector('.wti-modal-btn');

  if (!modalContent.contains(event.target) && event.target !== wtiButton) {
    closeModal();
  }
});

  document.addEventListener("DOMContentLoaded", function () {
    var urlParams = new URLSearchParams(window.location.search);
    var contactPosted = urlParams.get('form_type');
    const form = document.querySelector('.wti-contact-form');
    const successMessage = document.querySelector('.wire-success-message');
    successMessage.classList.remove('hidden');
    
    if (contactPosted === "contact") {
        openModal();
        if (form) form.classList.add("hidden");
        if (successMessage) successMessage.classList.remove("hidden");

        // Optional: Clean the URL
        if (history.replaceState) {
            const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
            history.replaceState(null, null, cleanUrl);
        }
    } else {
        if (form) form.classList.remove("hidden");
        if (successMessage) successMessage.classList.add("hidden");
    }
  });

document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#wire_contact_form");
  if (!form) return;

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    // Get form values
    const productName = form.querySelector(
      'input[name="contact[product_name]"]'
    )?.value;
    const productPrice = form.querySelector(
      'input[name="contact[product_price]"]'
    )?.value;
    const name = form.querySelector('input[name="contact[name]"]')?.value;
    const email = form.querySelector('input[name="contact[email]"]')?.value;
    const phone = form.querySelector('input[name="contact[phone]"]')?.value;

    if (!window._klOnsite) {
      console.error("Klaviyo library not loaded.");
      return;
    }

    // Identify customer (optional, but recommended)
    _klOnsite.push([
      "identify",
      {
        $email: email,
        $first_name: name,
        $phone_number: phone,
        product_name: productName,
        product_price: productPrice,
      },
    ]);

    // Track custom event
    _klOnsite.push([
      "track",
      "Wire-Transfer",
      {
        product_name: productName,
        product_price: productPrice,
        submitted_at: new Date().toISOString(),
        email: email,
        first_name: name,
        phone_number: phone,
      },
    ]);

    form.reset();
  });
});


